/* eslint-disable react-hooks/exhaustive-deps */
import Page from 'component/Page';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectCurrentUser } from 'redux/user/user.selector';
import Paths from 'util/paths';
import sendRequest from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import { getParams } from 'util/utils';
import './UserDetail.scss';
import UserAppIds from './UserAppIds';
import UserAppChannels from './UserAppChannels';

const USER_DETAIL_TAB = {
  APP_ID: 'appids',
  APP_CH: 'appchannels',
};

const UserDetailTabs = {
  appids: {
    title: string.POC_ACCOUNT_LIST,
    component: UserAppIds,
  },

  appchannels: {
    title: string.POC_CHANNEL_LIST,
    component: UserAppChannels,
  },
};

const UserDetail = ({ data = { userId: null } }) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const params = getParams();
  const [currentTab, setCurrentTab] = useState(
    params?.tab || USER_DETAIL_TAB.APP_ID,
  );
  const userId = data.userId || params?.userId || params?.id;
  const [userData, setUserData] = useState({});
  const [selectedUser, setSelectedUser] = useState(userId);
  const history = useHistory();

  //------------------------------FUNCTIONS----------------------------------------------------------
  useEffect(() => {
    if (!selectedUser) {
      return;
    }
		sendRequest({
			url: `${Urls.admin.account}/${selectedUser}`,
		}).then((response) => {
			const { result } = response;
			setUserData(result);
		});
  }, [selectedUser]);

  //-------------------------------RETURN------------------------------------------------------------
	return (
		<>
			<Page
        className="screen-user-detail"
        title={
          <>
            {`${userData.email}の${UserDetailTabs[currentTab].title}`}
            {/* {deviceLists.length > 1 && (
              <>
                <Button
                  className="device-select"
                  onClick={HandleUpButtonClicked}
                >
                  ↑
                </Button>
                <Button
                  className="device-select"
                  onClick={HandleDownButtonClicked}
                >
                  ↓
                </Button>
              </>
            )} */}
          </>
        }
        body={
					<>
						<Tabs
							activeKey={currentTab}
							onSelect={(t) => {
								setCurrentTab(t);
								history.push(`${Paths.user.details}/?id=${userId}&tab=${t}`);
							}
						}>
							{Object.keys(UserDetailTabs).map((t, index) => {
								let tab = UserDetailTabs[t];
								let TabComponent = tab.component;
								if (!TabComponent) {
									return null;
								}
								return (
									<Tab key={index} eventKey={t} title={tab.title}>
										{currentTab === t && (
											<TabComponent userId={selectedUser} />
										)}
									</Tab>
								);
							})}
						</Tabs>
					</>
        }
			/>
		</>
	);
};

export default UserDetail;
